<template>
  <div class="eemo-page-shell" style="background: white;">
    <div class="container" v-if="state === 2">
      <div class="row" style="margin-top: 30px;">
        <div class="col-12">{{message}}</div>
      </div>
    </div>

    <div class="container" v-else-if="pendingPayment">
      <div class="row" style="margin-top: 30px;">
        <div class="col-12">Waiting for payment confirmation...</div>
      </div>
    </div>

    <div class="container" v-else-if="inviteMode && !passView">
      <div class="row" style="margin-top: 30px;">
        <div class="col-12">Loading...</div>
      </div>
    </div>

    <div class="container" v-else-if="inviteMode && inviteExpired">
      <div class="row" style="margin-top: 30px;">
        <div class="col-12" style="font-size: 22px; font-weight: bold;">Invitation expired</div>
        <div class="col-12" style="margin-top: 16px; line-height: 1.5;">
          This invitation has already been used.
        </div>
      </div>
    </div>

    <div class="container" v-else-if="inviteMode">
      <div class="row" style="margin-top: 20px;">
        <div class="col-12" style="line-height: 50px; font-size: 22px; font-weight: bold;">
          You've been sent a pass
        </div>
        <div class="col-12" v-if="merchant !== false" style="margin-top: 5px;">
          <div style="width: 100%; height: 120px; background-position: center; background-repeat: no-repeat; background-size: contain;"
               v-bind:style="{'backgroundImage': 'url(' + (merchant.logo || merchant.imageUrl) + ')'}">
          </div>
          <div style="font-size: 20px; font-weight: bold; margin-top: 5px;">{{merchant.title}}</div>
        </div>
        <div class="col-12" style="margin-top: 10px; line-height: 1.5;">
          Enter your email to accept. You can also send a message to the person who bought it.
        </div>
        <div class="col-12" style="margin-top: 10px;">
          <div style="text-align: left; padding-left: 10px; padding-top: 20px;">Email *</div>
          <input type="email" class="form-control text-center" v-model="email" style="background: #fff;" placeholder="email"/>
        </div>
        <div class="col-12" style="margin-top: 10px;">
          <div style="text-align: left; padding-left: 10px;">Name (optional)</div>
          <input type="text" class="form-control text-center" v-model="name" style="background: #fff;" placeholder="name"/>
        </div>
        <div class="col-12" style="margin-top: 10px;">
          <div style="text-align: left; padding-left: 10px;">Message to sender (optional)</div>
          <textarea class="form-control" v-model="inviteMessage" rows="3" maxlength="500"
                    placeholder="Say thank you (optional)"></textarea>
        </div>
        <div class="col-12 text-left" style="margin-top: 15px;" v-if="merchant !== false">
          <span v-if="allowMarketing === true" style="font-size: 22px; color: #2F77E4;" @click="allowMarketing = !allowMarketing"><i class="fas fa-check-square"></i></span>
          <span v-else style="font-size: 22px;" @click="allowMarketing = !allowMarketing"><i class="far fa-square"></i></span>
          <b>{{merchant.title}}</b> will send you offers or news by email unless you object by unchecking this box.
        </div>
        <div class="col-12" style="margin-top: 8px; color: #c0392b;" v-if="inviteError">{{inviteError}}</div>
      </div>
      <div class="row">
        <div class="col-12" style="margin-top: 30px; padding-bottom: 10px;">
          <button class="positive-button"
                  style="padding: 16px 50px; border: none; width: 100%; background: #E84725; color: white; font-weight: bold; border-radius: 10px;"
                  @click="acceptInvite">
            Accept pass
          </button>
        </div>
      </div>
    </div>

    <div class="container" v-else-if="giftPurchaseComplete">
      <div class="row" style="margin-top: 30px;">
        <div class="col-12" style="font-size: 22px; font-weight: bold;">Gift sent</div>
        <div class="col-12" style="margin-top: 16px; line-height: 1.5;">
          Thank you. We've emailed the pass to <b>{{passView.email}}</b>.
        </div>
      </div>
    </div>

    <div class="container" v-else-if="!passView">
      <div class="row" style="margin-top: 30px;">
        <div class="col-12">Loading...</div>
      </div>
    </div>

    <div class="container" v-else>
      <div class="row" v-if="purchaseSuccess" style="margin-top: 30px;">
        <div class="col-12" style="font-size: 22px; font-weight: bold;">Thank you for your purchase</div>
        <div class="col-12" style="margin-top: 12px; line-height: 1.5;">
          Your pass is ready.
        </div>
      </div>
      <div class="row" v-if="showShare">
        <div class="col-12" style="margin-top: 20px;">
          <InviteShareButtons :url="inviteUrl" item-label="pass"
                               :merchant-title="merchant && merchant.title ? merchant.title : ''"/>
        </div>
      </div>

      <div class="row" v-if="showRegister">
        <div class="col-12" style="margin-top: 20px; line-height: 50px; font-size: 22px; font-weight: bold;">
          Your Pass
        </div>
        <div class="col-12" v-if="merchant !== false" style="margin-top: 5px;">
          <div style="width: 100%; height: 120px; background-position: center; background-repeat: no-repeat; background-size: contain;"
               v-bind:style="{'backgroundImage': 'url(' + (merchant.logo || merchant.imageUrl) + ')'}">
          </div>
          <div style="font-size: 20px; font-weight: bold; margin-top: 5px;">{{merchant.title}}</div>
        </div>
        <div class="col-12" style="margin-top: 10px;">
          Register your pass with your email address to keep it on your phone.
        </div>
        <div class="col-12" style="margin-top: 10px;">
          <div style="text-align: left; padding-left: 10px; padding-top: 20px;">Email</div>
          <input type="email" class="form-control text-center" v-model="email" style="background: #fff;" placeholder="email"/>
        </div>
        <div class="col-12" style="margin-top: 10px;">
          <div style="text-align: left; padding-left: 10px;">Name (optional)</div>
          <input type="text" class="form-control text-center" v-model="name" style="background: #fff;" placeholder="name"/>
        </div>
        <div class="col-12 text-left" style="margin-top: 15px;" v-if="merchant !== false">
          <span v-if="allowMarketing === true" style="font-size: 22px; color: #2F77E4;" @click="allowMarketing = !allowMarketing"><i class="fas fa-check-square"></i></span>
          <span v-else style="font-size: 22px;" @click="allowMarketing = !allowMarketing"><i class="far fa-square"></i></span>
          <b>{{merchant.title}}</b> will send you offers or news by email unless you object by unchecking this box.
        </div>
        <div class="col-12" style="margin-top: 30px; padding-bottom: 10px;">
          <button class="positive-button"
                  style="padding: 16px 50px; border: none; width: 100%; background: #E84725; color: white; font-weight: bold; border-radius: 10px;"
                  @click="submit">
            Register My Pass
          </button>
        </div>
      </div>

      <div class="row" v-if="showCard">
        <div class="col-12" style="margin-top: 20px;">
          <div style="background: linear-gradient(145deg, #0a2a52 0%, #031635 55%, #021024 100%); color: white; padding: 20px; border-radius: 10px; box-shadow: 0 8px 24px rgba(3, 22, 53, 0.28);">
            <div v-if="merchant !== false">
              <div style="font-size: 20px; font-weight: 700; line-height: 1.2;">Pass</div>
              <div style="margin-top: 8px; font-size: 16px; font-weight: 500; line-height: 1.2;">{{merchant.title}}</div>
              <div v-if="merchantAddress" style="margin-top: 4px; font-size: 12px; font-weight: 400; line-height: 1.35; opacity: 0.8;">{{merchantAddress}}</div>
            </div>
            <div style="margin-top: 12px; font-size: 18px; font-weight: 600; line-height: 1.3;">
              {{passView.planTitle && passView.planTitle.length > 0 ? passView.planTitle : 'Pass'}}
            </div>
            <div v-if="planSummary" style="margin-top: 6px; font-size: 13px; font-weight: 400; line-height: 1.4; opacity: 0.85;">
              {{planSummary}}
            </div>
            <div style="margin-top: 15px; font-size: 42px; font-weight: bold;" v-if="passView.status >= 0">
              {{passView.usesPerWeek - passView.usesThisWeek}}
            </div>
            <div style="margin-top: 6px;" v-if="passView.status >= 0">
              of {{passView.usesPerWeek}} uses left this week
            </div>
            <div style="margin-top: 15px; font-weight: bold;" v-else>
              {{statusText(passView.status)}}
            </div>
            <div style="margin-top: 15px;" v-if="passView.qrCode">
              <img :src="passView.qrCode" style="width: 200px; border-radius: 10px; background: white; padding: 8px;"/>
            </div>
            <div style="margin-top: 10px; font-size: 13px;">
              Starts {{dateString(passView.validFrom)}}
              <span v-if="passView.validTo > 0"> · Expires {{dateString(passView.validTo)}}</span>
              <span v-else> · No expiry</span>
            </div>
          </div>
        </div>
        <div class="col-12 text-center" style="margin-top: 20px;" v-if="showApple && passView.status >= 0">
          <a :href="walletUrl"
             style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; background: #000; color: #fff; padding: 14px 28px; border-radius: 10px; text-decoration: none; font-weight: bold; font-size: 16px;">
            <i class="fab fa-apple" style="font-size: 20px; line-height: 1;"></i>
            Add to Apple Wallet
          </a>
        </div>
        <div class="col-12 text-center" style="margin-top: 12px;" v-if="showGoogle && passView.status >= 0">
          <a :href="googleWalletUrl"
             style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; background: #000; color: #fff; padding: 14px 28px; border-radius: 10px; text-decoration: none; font-weight: bold; font-size: 16px;">
            <i class="fab fa-google" style="font-size: 18px; line-height: 1;"></i>
            Add to Google Wallet
          </a>
        </div>
        <div class="col-12 text-center" style="margin-top: 25px; margin-bottom: 10px;" v-if="passView.email">
          Registered to {{passView.email}}
        </div>
        <div class="col-12" style="margin-top: 20px;" v-if="passView.status >= 0 && passView.email">
          <InviteShareButtons :url="inviteUrl" item-label="pass"
                               :merchant-title="merchant && merchant.title ? merchant.title : ''"/>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row" style="margin-top: 50px;">
        <div class="col-12" style="font-size: small;">
          <b>Notice</b><br/>
          Your email address is only used to keep your pass and will not be shared with any third party.
        </div>
        <div class="col-12">
          <br/>
          <b>Show Me The Menu</b>
          <br/>
          A brand of Borium Studio Limited
          <br/><br/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {acceptPassInvite, emailTokenFromQueryOrUrl, getPass, getPassGoogleWalletUrl, getPassWalletUrl, registerPass} from "../api/borium";
import InviteShareButtons from "./InviteShareButtons.vue";

export default {
  name:'PassRegister',
  components: { InviteShareButtons },
  data() {
    return {
      code:'',
      email:'',
      name:'',
      inviteMessage: '',
      inviteError: '',
      inviteAccepted: false,
      allowMarketing:true,
      state:0,
      message:'',
      passView:false,
      merchant:false,
      pendingPayment:false,
      pollTimer:null,
    }
  },
  computed: {
    emailToken: function() {
      return emailTokenFromQueryOrUrl(this.$route.query.e, this.passView && this.passView.registerUrl);
    },
    walletUrl: function() {
      return getPassWalletUrl(this.code, this.emailToken);
    },
    googleWalletUrl: function() {
      return getPassGoogleWalletUrl(this.code, this.emailToken);
    },
    showApple: function() {
      return this.isApple || !this.isGoogle;
    },
    showGoogle: function() {
      return this.isGoogle || !this.isApple;
    },
    inviteMode: function() {
      return !this.inviteAccepted && this.$route.path.indexOf('/pass/invite') === 0;
    },
    purchaseSuccess: function() {
      return this.$route.query.result === 'success';
    },
    giftPurchaseComplete: function() {
      return this.purchaseSuccess
        && this.passView
        && this.passView.sentAsGift;
    },
    inviteExpired: function() {
      return this.passView && !this.passView.inviteOpen;
    },
    showShare: function() {
      return this.passView && this.passView.inviteOpen && !this.passView.email;
    },
    showCard: function() {
      return this.passView && this.passView.email;
    },
    showRegister: function() {
      return this.passView && !this.passView.email && !this.passView.inviteOpen;
    },
    inviteUrl: function() {
      return window.location.origin + '/pass/invite?code=' + encodeURIComponent(this.code);
    },
    isApple: function() {
      let ua = navigator.userAgent || '';
      return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && 'ontouchend' in document);
    },
    isGoogle: function() {
      return /Android/.test(navigator.userAgent || '');
    },
    merchantAddress: function() {
      if (!this.merchant) {
        return '';
      }
      let parts = [];
      if (this.merchant.address) {
        parts.push(String(this.merchant.address).replace(/\n/g, ', '));
      }
      if (this.merchant.city) parts.push(this.merchant.city);
      if (this.merchant.postCode) parts.push(this.merchant.postCode);
      return parts.join(', ');
    },
    planSummary: function() {
      if (!this.passView) {
        return '';
      }
      let uses = this.passView.usesPerWeek || 5;
      let food = this.passView.foodPerUse || 1;
      let drink = this.passView.drinkPerUse || 1;
      let text = uses + ' uses per week · ' + food + ' food + ' + drink + ' drink each use';
      if (this.passView.validDays > 0) {
        text += ' · valid ' + this.passView.validDays + ' days';
      } else {
        text += ' · no expiry';
      }
      return text;
    }
  },
  mounted() {
    this.initialise();
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  },
  methods: {
    initialise: function() {
      if(this.$route.query.result === 'failed') {
        this.message = 'Payment was cancelled or failed.';
        this.state = 2;
        return;
      }
      if(this.$route.query.code !== undefined) {
        this.$data.code = this.$route.query.code;
      }
      if(this.$data.code === null || this.$data.code.length === 0) {
        this.$data.message = 'No pass code provided';
        this.$data.state = 2;
        return;
      }
      this.loadPass(true);
    },
    loadPass: function(startPoll) {
      let self = this;
      getPass(this.$data.code, this.$route.query.e, this.inviteMode)
        .then(function(data) {
          if(data.success === true) {
            if(data.merchant !== undefined && data.merchant !== null) {
              self.$data.merchant = data.merchant;
            }
            if(data.item.status === -1) {
              self.pendingPayment = true;
              if (startPoll && !self.pollTimer) {
                self.pollTimer = setInterval(function() {
                  self.loadPass(false);
                }, 2500);
              }
              return;
            }
            self.pendingPayment = false;
            if (self.pollTimer) {
              clearInterval(self.pollTimer);
              self.pollTimer = null;
            }
            self.$data.passView = data.item;
            self.keepEmailTokenInRoute(data.item);
          } else {
            self.$data.message = data.message;
            self.$data.state = 2;
          }
        })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
        })
    },
    keepEmailTokenInRoute: function(item, path) {
      let token = emailTokenFromQueryOrUrl(this.$route.query.e, item && item.registerUrl);
      if (!token) {
        return;
      }
      if (this.$route.query.e === token && !path) {
        return;
      }
      let query = Object.assign({}, this.$route.query);
      query.code = this.code;
      query.e = token;
      this.$router.replace({ path: path || this.$route.path, query: query }).catch(function() {});
    },
    submit: function() {
      if(this.$data.email === null || this.$data.email.length === 0) {
        return;
      }
      let self = this;
      registerPass({
        code: this.$data.code,
        email: this.$data.email.trim().toLowerCase(),
        name: this.$data.name,
        allowMarketing: this.$data.allowMarketing,
        e: this.emailToken,
      })
        .then(function(data) {
          if(data.success === true) {
            if(data.merchant !== undefined && data.merchant !== null) {
              self.$data.merchant = data.merchant;
            }
            self.$data.passView = data.item;
            self.keepEmailTokenInRoute(data.item);
          } else {
            self.$data.message = data.message;
            self.$data.state = 2;
          }
        })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
        })
    },
    acceptInvite: function() {
      this.inviteError = '';
      if (!this.email || this.email.indexOf('@') < 0) {
        this.inviteError = 'Email is required';
        return;
      }
      let self = this;
      acceptPassInvite({
        code: this.code,
        email: this.email.trim().toLowerCase(),
        name: this.name,
        message: this.inviteMessage,
        allowMarketing: this.allowMarketing,
      })
        .then(function(data) {
          if (data.success === true) {
            self.inviteAccepted = true;
            if (data.merchant) {
              self.merchant = data.merchant;
            }
            if (data.item) {
              self.passView = data.item;
            }
            self.keepEmailTokenInRoute(data.item, '/pass/register');
          } else {
            self.inviteError = data.message || 'Could not accept this invitation';
          }
        })
        .catch(function() {
          self.inviteError = 'Could not accept this invitation';
        });
    },
    statusText: function(status) {
      if(status === -10) return 'This pass has expired';
      if(status === -20) return 'This pass has been cancelled';
      if(status === -5) return 'This pass is suspended';
      return '';
    },
    dateString: function(millis) {
      if(!millis || millis === 0) {
        return '-';
      }
      return new Date(millis).toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'});
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PassRegister.vue